export const licenseInfoBreakpoints = {
  small: 0,
  medium: 133,
  large: 219,
};
export const statusInfoChartBreakpoints = {
  small: 0,
  medium: 193,
  large: 219,
};

export const INITIATOR_TYPES = {
  All: 'All',
  Fixed: 'Fixed',
  Floating: 'Floating',
};

export const CLOUD_LICENSE_TYPES = {
  Trial: 'trial',
};
export const CLOUD_LICENSE_STATUSES = {
  Expired: 'expired',
  Active: 'active',
  Disabled: 'disabled',
};

export const LICENSE_INFO_TITLE = {
  cloudHours: 'Cloud Hours',
  initiators: 'Initiators',
  ciInitiators: 'CI Initiators',
  cacheCores: 'Cache Cores',
  helperCores: 'Helper Cores',
};
